/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import PulpoField from '../../../pulpo_visualizer/fields';
import styles from '../forms.module.scss';

class DefaultFields extends Component {
  render() {
    const {
      handleAnswerChanged,
      answers,
      showFormErrors,
      handleFieldErrorChanged,
      userAttributes,
      disableFields
    } = this.props;
    return (
      <div className={styles.details_form}>
        {userAttributes.name && (
        <PulpoField key="name" id="name" type="string" title="Name"
          translationID="forms.complete.name"
          handleValueChange={(a, b) => handleAnswerChanged(a, b, 'default')}
          answer={answers.name} isRequired
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
          disabled={disableFields && disableFields.name}
        />
        )}
        {userAttributes.email && (
        <PulpoField key="email" id="email" type="string" title="Email"
          translationID="forms.complete.email"
          handleValueChange={(a, b) => handleAnswerChanged(a, b, 'default')}
          answer={answers.email} isRequired
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
          disabled={disableFields && disableFields.email}
        />
        )}
        {userAttributes.phone && (
        <PulpoField key="phone" id="phone" type="telephone"
          title="Phone" isRequired
          translationID="forms.complete.phone"
          handleValueChange={(a, b) => handleAnswerChanged(a, b, 'default')}
          answer={answers.phone}
          showFieldErrors={showFormErrors}
          handleFieldErrorChanged={handleFieldErrorChanged}
        />
        )}
      </div>
    );
  }
}

DefaultFields.propTypes = {
  handleAnswerChanged: PropTypes.func.isRequired,
  answers: PropTypes.shape({}).isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool.isRequired
};


export default withRouter(DefaultFields);
